var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-submenu",
    { attrs: { index: _vm.index } },
    [
      _c("template", { slot: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._l(_vm.menu.exploreList, function(item) {
        return [
          !item.leaf
            ? [
                _c("loop-item", {
                  key: item.id,
                  attrs: { menu: item, index: item.id, title: item.name }
                })
              ]
            : _c("el-menu-item", { key: item.id }, [_vm._v(_vm._s(item.name))])
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }